import { __decorate } from "tslib";
import { Component, Prop, Vue } from 'vue-property-decorator';
let AmFeExpandSider = class AmFeExpandSider extends Vue {
  get width() {
    if (!this.asideWidth || this.asideWidth === '0px') return 0;
    return parseInt(this.asideWidth.replace('px', ''));
  }
  get siderClass() {
    return this.bordered ? 'lc-am-expand-sider-bordered' : '';
  }
  get asideClass() {
    if (!this.togglePosition || this.togglePosition === 'top') return '';
    if (this.togglePosition === 'center') return 'toggle-position-center';
    return 'toggle-position-bottom';
  }
  get asideStyle() {
    return {
      padding: this.asidePadding || void 0
    };
  }
  get bodyStyle() {
    return {
      padding: this.bodyPadding || void 0
    };
  }
};
AmFeExpandSider.componentName = 'AmFeExpandSider';
__decorate([Prop({
  default: false
})], AmFeExpandSider.prototype, "bordered", void 0);
__decorate([Prop({
  default: 'top'
})], AmFeExpandSider.prototype, "togglePosition", void 0);
__decorate([Prop({
  default: ''
})], AmFeExpandSider.prototype, "asideWidth", void 0);
__decorate([Prop({
  default: '0px'
})], AmFeExpandSider.prototype, "asidePadding", void 0);
__decorate([Prop({
  default: '16px'
})], AmFeExpandSider.prototype, "bodyPadding", void 0);
AmFeExpandSider = __decorate([Component({
  name: 'AmFeExpandSider'
})], AmFeExpandSider);
export default AmFeExpandSider;